export default function Section({ children, name }) {
  return (
    <section className={name}>
      <h2 className="section-header">{name}</h2>
      <div className="section-content">{children}</div>
    </section>
  )
}
